<button class="small-button" *ngIf="!useSmallButton && !useDefaultButton" [ngClass]="{'full-width': fullWidth}" (click)="startScan()">Scan</button>

<button class="default-button" *ngIf="useDefaultButton" [ngClass]="{'full-width': fullWidth}" (click)="startScan()">Scan Traceability Barcode</button>

<div *ngIf="useSmallButton" class="upload-condensed-button" (click)="startScan()">
    <span>Scan</span>
</div>